import { hrms, hrmsWithPath } from "../../services/http/api/rest";

const base = '/v1/';
const rest = hrmsWithPath("/v1/document");

const utils = {
    countriesnow: {
        get: (id: string) => hrms.get('/{{id}}', {id}),
        changeStatus: (id: string) => hrms.put('/{{id}}/updateStatus', {id}),

        getCountries: () => hrms.get("https://countriesnow.space/api/v0.1/countries", {}),
        getStates: (country: string) => hrms.get("https://countriesnow.space/api/v0.1/countries/states/q", {}, {country: country}),
        getCities: (country: string, state: string) => hrms.get("https://countriesnow.space/api/v0.1/countries/state/cities/q", {}, {
            country: country,
            state: state
        }),
        getAllCountriesDialCodeAndFlag: () => hrms.get("https://countriesnow.space/api/v0.1/countries/info?returns=flag,unicodeFlag,dialCode", {}),
    },
    weather: {
        get: (data: any) => hrms.get("https://api.open-meteo.com/v1/forecast", {}, data),
    },
    quotes: {
        // get: () => hrms.get("https://api.api-ninjas.com/v2/quoteoftheday", {}, {categories: "success,inspirational"}, {"X-Api-Key": process.env.REACT_APP_QUOTE_API_KEY}),
        // get: () => hrms.get("https://dummyjson.com/quotes/1", {}, {}, {}),
        get: (quoteId: any) => hrms.get(`https://dummyjson.com/quotes/${quoteId}`, {}, {}, {})
        // get: () => hrms.get("https://motivational-spark-api.vercel.app/api/quotes/random", {}, {}, {}),
    },
    images: {
        get: (pageNumber: number, pageSize: number) => hrms.get(`https://picsum.photos/v2/list`, {}, {
            'page': pageNumber,
            'limit': pageSize
        })
    },
    articles: {
        get: () => hrms.get('https://dev.to/api/articles',{},{"state":"rising","per_page":"6"})
    }
}

export default utils;
